var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headder"},[_c('div',{staticClass:"head-title wMax"},[_c('img',{attrs:{"src":require("../../../../public/logo3.png"),"alt":"logo"}}),_c('i',[_vm._v("广西区委党校")]),_c('i',{staticClass:"point"},[_vm._v(".")]),_c('i',[_vm._v("大数据")])])])
}]

export { render, staticRenderFns }